import React from "react";
import AccountsListPage, { fmtDate } from "./accounts/AccountsShared";

const statusBadge = (status = "") => {
  const s = String(status || "").toLowerCase();
  const cls =
    s === "approved" ? "success" : s === "rejected" ? "danger" : "secondary";
  return <span className={`badge bg-${cls}`}>{status || "pending"}</span>;
};

const userText = (u) => {
  if (!u) return "—";
  return u.fullName || u.mobile || "—";
};

const amountText = (n) => {
  const v = Number(n || 0);
  return `₹ ${v.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
};

const AdminPayrollApprovals = () => (
  <AccountsListPage
    title="Payroll Approvals"
    subtitle="Accounts raises salary; admin approves and disburses from this panel."
    endpoint="/admin/payroll"
    columns={[
      { key: "employee", label: "Employee" },
      { key: "month", label: "Month" },
      { key: "amount", label: "Amount", render: (r) => amountText(r.amount) },
      { key: "status", label: "Status", render: (r) => statusBadge(r.status) },
      { key: "createdBy", label: "Raised By", render: (r) => userText(r.createdBy) },
      { key: "approvedBy", label: "Approved By", render: (r) => userText(r.approvedBy) },
      { key: "approvedAt", label: "Approved On", render: (r) => fmtDate(r.approvedAt) },
      { key: "disbursedAt", label: "Disbursed On", render: (r) => fmtDate(r.disbursedAt) },
      { key: "createdAt", label: "Created On", render: (r) => fmtDate(r.createdAt) },
    ]}
    approvePerms={[]}
  />
);

export default AdminPayrollApprovals;
